import { Injectable, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class NotTranslatedService {
  constructor(private readonly injector: Injector) {}

  instant(key: string): string {
    let translateService: TranslateService;
    try {
      translateService = this.injector.get(TranslateService);
      return translateService.instant(key) || key;
    } catch {
      return key;
    }
  }
}
